import * as ec from '@attain-apps/fe/web/main/lib/entity-collection'
import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type { Collection } from '../collection'
import type { TypeParams } from '../types'

/**
 * Reloads the collection when an occupant is added, removed, or has its
 * payrolls updated.
 */
export const reloadOnOccupantChange = store.effects.create(
  (_: ec.Collection<TypeParams>['feature'], collection: Collection) =>
    ec.models.CollectionProducer.getEc$(ec.Name.Predefined.SpaceOccupant, {
      waitUntilReady: true,
    }).pipe(
      rxjs.switchMap(occupantsEc =>
        occupantsEc.plugins.editingPlugin.feature.actions.submit.success
          .observe()
          .pipe(
            rxjs.map(() =>
              collection.plugins.currentEntityPlugin.feature.actions.getEntity
                .from('(effect) reload on occupant change')
                .create({}),
            ),
          ),
      ),
    ),
)
